import { default as agenda } from './agenda';
import { default as alerts } from './alerts';
import { default as analyses } from './analyses';
import { default as app } from './app';
import { default as company } from './company';
import { default as corporateStructure } from './corporateStructure';
import { default as dashboards } from './dashboards';
import { default as dialog } from './dialog';
import { default as financialManagement } from './financialManagement';
import { default as forecasts } from './forecasts';
import { default as foresights } from './foresights';
import { default as indicators } from './indicators';
import { default as insight } from './insight';
import { default as integrations } from './integrations';
import { default as market } from './market';
import { default as notifications } from './notifications';
import { default as stakeholders } from './stakeholders';
import { default as strategy } from './strategy';
import { default as subscription } from './subscription';
import { default as workshop } from './workshop';

export default {
    agenda,
    alerts,
    analyses,
    app,
    company,
    corporateStructure,
    dashboards,
    dialog,
    financialManagement,
    forecasts,
    foresights,
    indicators,
    insight,
    integrations,
    market,
    notifications,
    stakeholders,
    strategy,
    subscription,
    workshop
};
